import React, { useEffect, useState } from 'react'
import { FaTimes } from 'react-icons/fa'
import Swal from 'sweetalert2'
import { useLaserEyes, WalletIcon } from '@omnisat/lasereyes-react'
import { Wallet } from '@coinbase/onchainkit/wallet'
import { UNISAT, XVERSE, OYL, LEATHER, MAGIC_EDEN, OKX, PHANTOM, WIZZ, ORANGE } from '@omnisat/lasereyes-core'

const WalletModal = ({ isOpen, onClose }) => {
  const [activeTab] = useState('popular')
  const { connect, connected, address } = useLaserEyes()
  const connectUniSatWallet = async () => {
    if (window.unisat) {
      try {
        // await connect(UNISAT)
        await connect(UNISAT)
        Swal.fire({
          toast: true,
          position: 'top',
          icon: 'success',
          title: 'UniSat Wallet Connected',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          background: '#1a1a1a',
          color: '#fff',
        }).then(() => {
          onClose()
        })
      } catch (error) {
        console.error('UniSat Wallet Connection Error:', error)
      }
    } else {
      alert('UniSat Wallet is not installed. Please install it.')
    }
  }

  const connectXverseWallet = async () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    try {
      await connect(XVERSE)
      // onWalletConnect(address, 'xverse', publicKey);
      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'success',
        title: 'Xverse Wallet Connected',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#1a1a1a',
        color: '#fff',
      }).then(() => {
        onClose()
      })
    } catch (error) {
      console.error('Error connecting to Xverse using sats-connect:', error)
      if (isMobile) {
        const yourDappURL = encodeURIComponent(`${window.location.origin}/xverse/connect`)
        const xverseDeepLink = `https://connect.xverse.app/browser?url=${yourDappURL}`

        window.location.href = xverseDeepLink
      }
    }
  }

  const connectWallet = async wallet => {
    try {
      await connect(wallet)
      Swal.fire({
        toast: true,
        position: 'top',
        icon: 'success',
        title: `${wallet} Wallet Connected`,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#1a1a1a',
        color: '#fff',
      }).then(() => {
        onClose()
      })
    } catch (error) {
      console.error('Error connecting to Xverse using sats-connect:', error)
    }
  }

  if (!isOpen) return null

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black-80 backdrop-blur-2xl z-50'>
      <div
        className='bg-muted border border-white-10 rounded-2xl shadow-lg p-8 relative max-w-lg w-full sm:w-500px text-white overflow-scroll'
        style={{ height: '75%' }}
      >
        {/* Close Button */}
        <button className='absolute top-4 right-4 text-white-70 hover:text-accent transition-all' onClick={onClose}>
          <FaTimes size={20} />
        </button>

        {/* Title */}
        <h2 className='text-3xl font-bold text-center'>Connect Wallet</h2>
        <p className='text-textPrimary text-lg text-center mt-2'>Choose your preferred wallet to connect.</p>

        {/* Wallet List */}
        <div className='mt-6 space-y-4'>
          {activeTab === 'popular' && (
            <>
              {/* UniSat Wallet */}
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={connectUniSatWallet}
              >
                <img src='/unisat-icon.jpg' alt='UniSat' className='h-10 w-10 rounded-lg' />
                <span className='text-white'>UniSat Wallet</span>
              </button>

              {/* Xverse Wallet */}
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={connectXverseWallet}
              >
                <img src='/xverse-icon.jpg' alt='Xverse' className='h-10 w-10 rounded-lg' />
                <span className='text-white'>Xverse Wallet</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(OYL)}
              >
                <WalletIcon walletName={OYL} size={40} className='opacity-75 transition-opacity hover:opacity-100' />
                <span className='text-white'>{OYL}</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(LEATHER)}
              >
                <WalletIcon
                  walletName={LEATHER}
                  size={40}
                  className='opacity-75 transition-opacity hover:opacity-100'
                />
                <span className='text-white'>{LEATHER}</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(MAGIC_EDEN)}
              >
                <WalletIcon
                  walletName={MAGIC_EDEN}
                  size={40}
                  className='opacity-75 transition-opacity hover:opacity-100'
                />
                <span className='text-white'>{MAGIC_EDEN}</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(OKX)}
              >
                <WalletIcon walletName={OKX} size={40} className='opacity-75 transition-opacity hover:opacity-100' />
                <span className='text-white'>{OKX}</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(PHANTOM)}
              >
                <WalletIcon
                  walletName={PHANTOM}
                  size={40}
                  className='opacity-75 transition-opacity hover:opacity-100'
                />
                <span className='text-white'>{PHANTOM}</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(WIZZ)}
              >
                <WalletIcon walletName={WIZZ} size={40} className='opacity-75 transition-opacity hover:opacity-100' />
                <span className='text-white'>{WIZZ}</span>
              </button>
              <button
                className='flex items-center text-lg font-bold gap-4 w-full p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary hover:scale-105 transition-all duration-300 shadow-card border border-white-10'
                onClick={() => connectWallet(ORANGE)}
              >
                <WalletIcon walletName={ORANGE} size={40} className='opacity-75 transition-opacity hover:opacity-100' />
                <span className='text-white'>{ORANGE}</span>
              </button>
              <div className='flex items-center justify-center p-4 rounded-2xl bg-gradient-to-b from-secondary to-primary border border-white-10'>
                <Wallet />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default WalletModal
